export class ChannelsBalanceReportEntry {
    public channelName: string;
    public channelId: string;
    public channelHierarchyLevel: number;
    public cashIn: { key: string; value: number }[] = [];
    public cashOut: { key: string; value: number }[] = [];
    public cashBalance: { key: string; value: number }[] = [];
    public manualDeposit: { key: string; value: number }[] = [];
    public balance: { key: string; value: number }[] = [];

    public children: ChannelsBalanceReportEntry[] = [];
    public cashInIncludingChildren: { key: string; value: number }[] = [];
    public cashOutIncludingChildren: { key: string; value: number }[] = [];
    public cashBalanceIncludingChildren: { key: string; value: number }[] = [];
    public manualDepositIncludingChildren: { key: string; value: number }[] = [];
    public balanceIncludingChildren: { key: string; value: number }[] = [];

    public kitWithdrawn: boolean;
    public endShiftDeposited: boolean;

    constructor() {}

    parse(obj: any) {
        this.channelName = obj.ChannelName;
        this.channelId = obj.ChannelId;
        this.channelHierarchyLevel = obj.ChannelHierarchyLevel;

        for (let key in obj.CashIn) this.cashIn.push({ key: key, value: obj.CashIn[key] });
        for (let key in obj.CashOut) this.cashOut.push({ key: key, value: obj.CashOut[key] });
        for (let key in obj.CashBalance) this.cashBalance.push({ key: key, value: obj.CashBalance[key] });
        for (let key in obj.ManualDeposit) this.manualDeposit.push({ key: key, value: obj.ManualDeposit[key] });
        for (let key in obj.Balance) this.balance.push({ key: key, value: obj.Balance[key] });

        if (obj.Children && obj.Children.length > 0) {
            this.children = [];
            obj.Children.forEach((obj) => {
                var temp = new ChannelsBalanceReportEntry();
                temp.parse(obj);
                this.children.push(temp);
            });
        }

        for (let key in obj.CashInIncludingChildren) this.cashInIncludingChildren.push({ key: key, value: obj.CashInIncludingChildren[key] });
        for (let key in obj.CashOutIncludingChildren) this.cashOutIncludingChildren.push({ key: key, value: obj.CashOutIncludingChildren[key] });
        for (let key in obj.CashBalanceIncludingChildren) this.cashBalanceIncludingChildren.push({ key: key, value: obj.CashBalanceIncludingChildren[key] });
        for (let key in obj.ManualDepositIncludingChildren) this.manualDepositIncludingChildren.push({ key: key, value: obj.ManualDepositIncludingChildren[key] });
        for (let key in obj.BalanceIncludingChildren) this.balanceIncludingChildren.push({ key: key, value: obj.BalanceIncludingChildren[key] });

        this.kitWithdrawn = obj.KitWithdrawn;
        this.endShiftDeposited = obj.EndShiftDeposited;
    }
}
